<template>
    <div>

        <!-- title -->
        <div class="TQ_padding_12px TQ_bg_purple_dark TQ_border_bottom TQ_text_28px TQ_text_bold TQ_align_initial TQ_grid_col_1frAuto">

            <!-- drive title -->
            <div class="TQ_grid_verticalCenter">

                <tq-image :pb_src_r="ass_svg_drive_white"
                          @click.native="m_currentFolderPath_reset_f()"
                          class="TQ_width_24px TQ_verticalAlignMiddle TQ_clickable"/>

                <div class="TQ_verticalAlignMiddle TQ_padding_4px TQ_inline"></div>

                <div class="TQ_inline TQ_verticalAlignMiddle TQ_clickable TQ_textColor_hover_gold"
                     :class="{'TQ_text_underline2' : 0 === currentFoldersPath_ac.length}"
                     @click="m_currentFolderPath_reset_f()">
                    {{ass_strings.oneWord_drive[store_langCode_ve.val]}}
                </div>

                <div v-for="(folderFile_c, index_n) in currentFoldersPath_ac" class="TQ_inline TQ_verticalAlignMiddle">

                    <div class="TQ_inline">/ </div>
                    <div class="TQ_inline" v-if="index_n === currentFoldersPath_ac.length - 1">&nbsp</div>
                    <div @click="m_currentFolderPath_splice_f(index_n)"
                         class="TQ_inline"
                         :class="index_n === currentFoldersPath_ac.length - 1 ? 'TQ_text_underline2' : 'TQ_textColor_hover_gold TQ_clickable'">
                        {{folderFile_c.fi_fileName_s}}
                    </div>

                </div>
            </div>

            <!-- drive actions-->
            <div class="TQ_grid_verticalCenter">

                <!-- add new folder btn -->
                <tq-image :pb_src_r="ass_svg_newFolder_black"
                          :title="ass_strings.twoWords_newFolder[store_langCode_ve.val]"
                          v-if="currentFoldersPath_ac.length < 2"
                          @click.native="popup_newFolder_vb.val = true"
                          class="TQ_verticalAlignMiddle TQ_bg_white TQ_width_36px TQ_padding_4px TQ_borderRadius TQ_borderBox TQ_box_shadow2 TQ_Animation_smallBigSmall_infinite_hover TQ_clickable"/>

                <!-- space -->
                <div class="TQ_verticalAlignMiddle TQ_padding_4px TQ_inline"></div>

                <!-- add file btn -->
                <tq-image :pb_src_r="ass_img_newFile_c"
                          :title="ass_strings.twoWords_newFile[store_langCode_ve.val]"
                          @click.native="$refs.inputInput.click()"
                          class="TQ_verticalAlignMiddle TQ_bg_white TQ_width_36px TQ_padding_4px TQ_borderRadius TQ_borderBox TQ_box_shadow2 TQ_Animation_smallBigSmall_infinite_hover TQ_clickable"/>
                <input type="file" @change="m_addFileFromDevice_f" ref="inputInput" style="display: none;">

                <!-- space -->
                <div class="TQ_verticalAlignMiddle TQ_padding_4px TQ_inline"></div>

                <!-- info -->
                <tq-image :pb_src_r="ass_img_infoBtn_b"
                          :title="ass_strings.twoWords_moreInfo[store_langCode_ve.val]"
                          @click.native="popup_info_vb.val = true"
                          class="TQ_verticalAlignMiddle TQ_bg_white TQ_padding_2px TQ_borderBox TQ_width_36px TQ_box_shadow2 TQ_bg_circle TQ_Animation_smallBigSmall_infinite_hover TQ_clickable"/>

                <!-- space -->
                <div class="TQ_verticalAlignMiddle TQ_padding_4px TQ_inline"></div>

                <!-- back arrow-->
                <tq-image :pb_src_r="ass_img_leftArrow_w"
                          v-if="currentFoldersPath_ac.length > 0"
                          @click.native="m_currentFolderPath_pop_f"
                          class="TQ_width_24px TQ_verticalAlignMiddle TQ_clickable TQ_Animation_smallBigSmall_infinite_hover"/>
                <div v-else class="TQ_width_24px"></div>


            </div>

        </div>

        <!-- body -->
        <tq-loader-container :p_tq-loader_b="true" :p_show-loader_b="server_rootFiles_byUploadDate_c === undefined" class="TQ_bg_gray4">
            <div v-if="server_rootFiles_byUploadDate_c !== undefined">

                <!-- filter and order by-->
                <div>

                    <!-- filter -->
                    <div class="TQ_padding_8px TQ_inline">
                        <div class="TQ_text_bold TQ_text_20px TQ_align_initial">
                            {{ ass_strings.oneWord_filter[store_langCode_ve.val]}}
                        </div>
                        <div class="TQ_direction_ltr TQ_verticalAlignTop">
                            <tq-image :pb_src_r="ass_svg_photo_b"
                                      :class="filter_s === filterOptions_byLabel_s.image ? 'TQ_bg_purple_lite' : 'TQ_bg_white'"
                                      @click.native="m_clickFilter_f(filterOptions_byLabel_s.image)"
                                      class="TQ_width_56px TQ_height_36px TQ_clickable TQ_borderBox TQ_border TQ_borderRadius_left TQ_padding_4px TQ_box_shadow2" />
                            <tq-image :pb_src_r="ass_svg_film_b"
                                      :class="filter_s === filterOptions_byLabel_s.video ? 'TQ_bg_purple_lite' : 'TQ_bg_white'"
                                      @click.native="m_clickFilter_f(filterOptions_byLabel_s.video)"
                                      class="TQ_width_56px TQ_height_36px TQ_clickable TQ_borderBox TQ_border TQ_padding_4px TQ_box_shadow2" />
                            <tq-image :pb_src_r="ass_img_musicPlayer"
                                      :class="filter_s === filterOptions_byLabel_s.audio ? 'TQ_bg_purple_lite' : 'TQ_bg_white'"
                                      @click.native="m_clickFilter_f(filterOptions_byLabel_s.audio)"
                                      class="TQ_width_56px TQ_height_36px TQ_clickable TQ_borderBox TQ_border TQ_borderRadius_right TQ_padding_4px TQ_box_shadow2" />
                        </div>
                    </div>

                    <!-- order by-->
                    <div class="TQ_inline TQ_verticalAlignTop TQ_padding_8px">
                        <div class="TQ_text_bold TQ_text_20px TQ_align_initial">
                            {{ ass_strings.twoWords_orderBy[store_langCode_ve.val]}}
                        </div>
                        <div class="TQ_direction_ltr">
                            <div class="TQ_inline TQ_padding_8px TQ_width_72px TQ_clickable TQ_borderBox TQ_border TQ_borderRadius_left TQ_padding_4px TQ_box_shadow2 TQ_text_bold"
                                 :class="orderBy_s === orderByOptions_byLabel_s.date  ? 'TQ_bg_purple_lite_clean' : ''"
                                 @click="orderBy_s = orderByOptions_byLabel_s.date">
                                {{ ass_strings.oneWord_date[store_langCode_ve.val]}}
                            </div>
                            <div class="TQ_inline TQ_padding_8px TQ_width_72px TQ_clickable TQ_borderBox TQ_border TQ_borderRadius_right TQ_padding_4px TQ_box_shadow2 TQ_text_bold"
                                 :class="orderBy_s === orderByOptions_byLabel_s.name ? 'TQ_bg_purple_lite_clean' : ''"
                                 @click="orderBy_s = orderByOptions_byLabel_s.name">
                                {{ ass_strings.oneWord_name[store_langCode_ve.val]}}
                            </div>
                        </div>
                    </div>

                    <!--<div class="TQ_margin_top_8px TQ_inline TQ_verticalAlignTop TQ_padding_8px">-->
                    <!--    <tq-on-top-container >-->
                    <!--        <input slot="body" :placeholder="ass_strings.oneWord_search[store_langCode_ve.val]" class="TQ_verticalAlignMiddle TQ_padding_8px TQ_margin_top_16px">-->
                    <!--        <tq-image slot="topLeft" :pb_src_r="ass_img_searchEmpty_b"-->
                    <!--                  class="TQ_margin_top_16px TQ_verticalAlignMiddle TQ_width_20px TQ_borderRadius_left TQ_padding_8px" />-->
                    <!--    </tq-on-top-container>-->
                    <!--</div>-->

                </div>

                <!-- files -->
                <div v-for="file_c in co_currentFolderFiles_sortByDate_ac"
                     class="TQ_width_250px TQ_bg_white TQ_padding_4px TQ_margin_4px TQ_inline TQ_verticalAlignTop TQ_borderRadius">

                    <tq-on-top-container>
                        <!-- folder -->
                        <tq-image v-if="file_c.fi_m_isFolder_fb()"
                                  slot="body"
                                  :pb_src_r="ass_svg_folder_color"
                                  @click.native="m_currentFolderPath_push_f(file_c)"
                                  class="lc_folder TQ_clickable TQ_fullScreen TQ_borderBox TQ_padding_16px TQ_bg_hover_goldLite TQ_border TQ_borderRadius" />

                        <!-- file  -->
                        <div slot="body" v-else
                             @click="m_chooseFile_f(file_c)"
                             class="TQ_clickable TQ_bg_hover_goldLite TQ_border TQ_borderRadius">
                            <div class="TQ_border_bottom" v-if="file_c.fi_m_isAudio_fb()">
                                <tq-image :pb_src_r="ass_img_musicPlayer" class="TQ_width_52px TQ_padding_12px" />
                            </div>
                            <tq-display-file :file="file_c" pp_blur-img-height_s="140px" :p_fill-blur-img_b="true"/>
                        </div>

                        <!-- delete file -->
                        <tq-btn-approve
                            slot="topRight"
                            :title="ass_strings.oneWord_delete[store_langCode_ve.val]"
                            class="TQ_grid_center TQ_margin_4px "
                            :system-lang-code="store_langCode_ve.val"
                            :popup-text="ass_strings.question_deleteFile"
                            :approve-cb="() => {m_deleteFile_f(file_c)}">
                            <tq-image :pb_src_r="ass_img_garbage_w"
                                      class="TQ_width_20px TQ_padding_4px TQ_bg_red TQ_bg_circle TQ_border_white_2px TQ_box_shadow TQ_clickable"/>
                        </tq-btn-approve>

                        <!-- move files-->
                        <tq-image :pb_src_r="ass_svg_arrow_round_black"
                                  slot="topLeft"
                                  @click.native="m_showMoveFilePopup_f(file_c)"
                                  :title="ass_strings.threeWords_moveToFolder[store_langCode_ve.val]"
                                  class="TQ_width_20px TQ_padding_4px TQ_margin_2px TQ_bg_white TQ_bg_circle TQ_box_shadow TQ_border_darkGray TQ_clickable"/>

                        <!-- Date-->
                        <div class="TQ_text_14px TQ_text_selectable TQ_bg_white_a TQ_align_end TQ_padding_2px TQ_borderRadius" slot="bottomLeft">
                            {{format_date_YYYY_MM_DD_fs(file_c.fi_uploadDate_t)}}
                        </div>

                    </tq-on-top-container>

                    <!-- fileName -->
                    <div  class="TQ_margin_2px">
                        <input v-if="currentEditFile_new_c && currentEditFile_new_c.fi_uploadDate_t === file_c.fi_uploadDate_t"
                               class="TQ_text_bold TQ_padding_2px TQ_width_100p TQ_borderBox TQ_center TQ_text_18px TQ_bg_gray4 "
                               ref="ref_fileName"
                               @keyup.enter="m_editFileName_saveNewName_f"
                               @keyup.esc="currentEditFile_new_c=null"
                               @focusout="m_editFileName_onBluer_f"
                               v-model="currentEditFile_new_c.fi_fileName_s"/>
                        <div v-else @click=m_clickFileName_f(file_c) class="TQ_text_selectable TQ_clickable TQ_text_18px TQ_padding_4px TQ_text_breakLongLine">
                            {{file_c.fi_m_fullName_s()}}
                        </div>
                    </div>

                </div>

                <!-- empty folder -->
                <div v-if="co_currentFolderFiles_sortByDate_ac.length === 0" class="TQ_padding_32px TQ_margin_16px TQ_text_24px">
                    {{ass_strings.twoWords_emptyFolder[store_langCode_ve.val]}}
                </div>

                <!-- load more button-->
                <div class="TQ_margin_bottom_8px">
                    <div class="TQ_inline TQ_padding_8px TQ_text_20px TQ_verticalAlignTop TQ_borderRadius TQ_bg_purple TQ_clickable TQ_margin_8px TQ_box_shadow2"
                         v-if="co_currentDisplayFiles_n < currentTotalAvailableFilesNum_n" @click="m_showMoreFiles_f">
                        {{ass_strings.threeWords_showMoreFiles[store_langCode_ve.val]}}
                    </div>
                </div>

            </div>
        </tq-loader-container>

        <!-- popup info-->
        <tq-popup :show="popup_info_vb" max-width="400px" padding="0" :show-close-btn="true">

            <!-- title -->
            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_24px">
                {{ass_strings.threeWords_tqDriveUsage[store_langCode_ve.val]}}
            </div>

            <!-- body -->
            <div class="TQ_center TQ_bg_white TQ_padding_8px_16px TQ_borderRadius TQ_text_20px">

                <div class="TQ_grid_col_autoAuto">
                    <div> {{ass_strings.oneWord_images[store_langCode_ve.val]}} </div>
                    <div> {{ format_sizeBytes_s(co_totalSize_byType_n.images_n) }}</div>

                    <div > {{ass_strings.oneWord_videos[store_langCode_ve.val]}} </div>
                    <div > {{ format_sizeBytes_s(co_totalSize_byType_n.videos_n) }}</div>

                    <div > {{ass_strings.oneWord_audio[store_langCode_ve.val]}} </div>
                    <div > {{ format_sizeBytes_s(co_totalSize_byType_n.audio_n) }}</div>
                </div>

                <hr>

                <div class="TQ_grid_col_autoAuto">
                    <div class="TQ_grid_verticalCenter TQ_text_bold"> {{ass_strings.oneWord_total[store_langCode_ve.val]}}</div>
                    <div class="TQ_grid_verticalCenter">
                        <div>
                            {{ format_sizeBytes_s(co_totalSize_sum_n) }}
                        </div>
                        <div class="TQ_border_top TQ_inline" v-if="server_currentUserData_moreInfo_c">
                            {{format_sizeBytes_s(server_currentUserData_moreInfo_c.udsmi_tqDriveSize_n)}}
                        </div>
                    </div>
                </div>

            </div>

            <!-- btn-->
            <!--<div class="TQ_padding_8px TQ_align_end TQ_border_top">-->
            <!--    <div class="TQ_padding_8px TQ_inline TQ_box_shadow TQ_borderRadius TQ_clickable TQ_bg_purple_dark "-->
            <!--         @click="popup_info_vb.val=false">-->
            <!--        {{ass_strings.oneWord_Continue[store_langCode_ve.val]}}-->
            <!--    </div>-->
            <!--</div>-->


        </tq-popup>

        <!-- popup new folder-->
        <tq-popup :show="popup_newFolder_vb" max-width="400px" padding="0" :show-close-btn="true">

            <!-- title -->
            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_24px">
                {{ass_strings.twoWords_newFolder[store_langCode_ve.val]}}
            </div>

            <!-- body -->
            <div class="TQ_center TQ_bg_white TQ_padding_8px_16px TQ_borderRadius TQ_text_20px">

                <input v-model="popup_newFolder_name_s" :placeholder="ass_strings.twoWords_folderName[store_langCode_ve.val]" class="TQ_padding_8px" >

            </div>

            <!-- btn-->
            <div class="TQ_padding_8px TQ_border_top TQ_grid_col_Auto1frAuto">

                <div class="TQ_padding_8px TQ_inline TQ_box_shadow TQ_borderRadius TQ_clickable TQ_bg_red "
                     @click="popup_newFolder_vb.val=false">
                    {{ass_strings.oneWord_cancel[store_langCode_ve.val]}}
                </div>

                <div></div>

                <div class="TQ_padding_8px TQ_inline TQ_box_shadow TQ_borderRadius TQ_clickable TQ_bg_green "
                     @click="m_createNewFolder_f">
                    {{ass_strings.oneWord_approve[store_langCode_ve.val]}}
                </div>
            </div>

        </tq-popup>

        <!-- popup move to folder-->
        <tq-popup :show="moveFile_showPopup_vb" max-width="400px" padding="0" :show-close-btn="true">

            <!-- title -->
            <div class="TQ_bg_purple_dark TQ_padding_8px TQ_text_24px">
                {{ass_strings.threeWords_moveToFolder[store_langCode_ve.val]}}
            </div>

            <!-- body -->
            <div class="TQ_center TQ_bg_white TQ_padding_8px_16px TQ_borderRadius TQ_text_20px">

                <div class="TQ_grid_col_1frAuto TQ_bg_gray3 TQ_padding_8px TQ_borderRadius TQ_margin_bottom_8px">
                    <div class="TQ_align_initial">

                        <div class="TQ_inline TQ_verticalAlignMiddle TQ_clickable TQ_textColor_hover_gold "
                             @click="moveFile_folderPath_c=[]">
                            {{ass_strings.oneWord_drive[store_langCode_ve.val]}}
                        </div>

                        <div v-for="(folderFile_c, index_n) in moveFile_folderPath_c" class="TQ_inline TQ_verticalAlignMiddle">

                            <div class="TQ_inline">/</div>
                            <div @click="moveFile_folderPath_c = moveFile_folderPath_c.splice(0,index_n+1)"
                                 class="TQ_inline"
                                 :class="index_n === moveFile_folderPath_c.length - 1 ? '' : 'TQ_textColor_hover_gold TQ_clickable'">
                                {{folderFile_c.fi_fileName_s}}
                            </div>
                        </div>
                    </div>

                    <!-- back arrow-->
                    <tq-image :pb_src_r="ass_img_leftArrow_b"
                              v-if="moveFile_folderPath_c.length > 0"
                              @click.native="moveFile_folderPath_c.pop()"
                              class="TQ_width_24px TQ_verticalAlignMiddle TQ_clickable TQ_Animation_smallBigSmall_infinite_hover"/>
                    <div v-else class="TQ_width_24px"></div>
                </div>

                <div v-for="file_c in co_moveFile_currentFolderFiles_sortByDate_ac"
                     @click="moveFile_folderPath_c.push(file_c)"
                     class="TQ_align_initial TQ_padding_8px TQ_margin_2px TQ_box_shadow TQ_text_breakLongLine TQ_clickable TQ_bg_hover_goldLite">
                    <tq-image :pb_src_r="ass_svg_folder_color" class="TQ_width_20px TQ_verticalAlignMiddle"/>
                    <div class="TQ_inline TQ_padding_4px TQ_verticalAlignMiddle"></div>

                    <div class="TQ_verticalAlignMiddle TQ_inline">
                        {{file_c.fi_m_fullName_s()}}
                    </div>
                </div>
            </div>

            <!-- btn-->
            <div class="TQ_padding_8px TQ_border_top TQ_grid_col_Auto1frAuto">

                <div class="TQ_padding_8px TQ_inline TQ_box_shadow TQ_borderRadius TQ_clickable TQ_bg_red "
                     @click="moveFile_showPopup_vb.val=false">
                    {{ass_strings.oneWord_cancel[store_langCode_ve.val]}}
                </div>
                <div></div>

                <div class="TQ_padding_8px TQ_inline TQ_box_shadow TQ_borderRadius TQ_clickable TQ_bg_green "
                     @click="m_moveFile_f">
                    {{ass_strings.oneWord_approve[store_langCode_ve.val]}}
                </div>
            </div>

        </tq-popup>

    </div>
</template>

<script>
    import {
        validator_enum_fb,
    } from "../../../functions/src/shareCode/Share_S_Validator";
    import {FB_File} from "../../../functions/src/shareCode/Share_S_Classes";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqImage from "../basic/TqImage";
    import {
        ass_img_add_b,
        ass_img_add_w,
        ass_img_garbage_w, ass_img_image,
        ass_img_info2_b,
        ass_img_infoBtn_b, ass_img_arrow_left_b,
        ass_img_arrow_left_w, ass_img_musicPlayer,
        ass_img_newFile_c, ass_img_searchEmpty_b, ass_img_videoPlayer,
        ass_svg_arrow_round_black,
        ass_svg_drive_white,
        ass_svg_folder_color,
        ass_svg_newFolder_black, ass_svg_film_b, ass_svg_photo_b,
    } from "@/assets/scripts/Ass_Files";
    import TqSelectImage from "../mediaComponenets/TqSelectImage";
    import {enum_fileType} from "../../../functions/src/shareCode/Share_S_Enum";
    import TqDisplayFile from "../mediaComponenets/TqDisplayFile";
    import {obj_forEach_f, obj_size_fn, obj_toArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVirables";
    import {notification_notify, notification_notify2} from "@/scripts/S_Notification";
    import {
        format_date_YYYY_MM_DD_fs,
        format_sizeBytes_s
    } from "../../../functions/src/shareCode/Share_S_Format";
    import TqLoaderContainer from "../basic/TqLoaderContainer";

    import {store_getStateValue_vo, store_setStateValue, store_var} from "@/store";
    import {
        serverPre_userFiles_add_f,
        serverPre_creatorFile_delete_f,
        serverPre_userFiles_get_f, serverPre_subUserData_moreInfo_get_f, serverPre_creatorFiles_update_f
    } from "@/scripts/Server/S_ServerPre";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "@/scripts/Server/S_ServerAuth";
    import TqPopup from "@/components/basic/TqPopup";
    import {date_setTimeout} from "@/scripts/S_Date";

    export default {
        name: "FcucDrive",
        components: {TqPopup, TqLoaderContainer, TqBtnApprove, TqOnTopContainer, TqDisplayFile, TqSelectImage, TqImage},
        props:{
            p_canChooseVideo_b:{
                type: Boolean,
                default : true,
            },
            p_canChooseImage_b:{
                type: Boolean,
                default : true,
            },
            p_canChooseAudio_b:{
                type: Boolean,
                default : true,
            },
            pe_chooseFile_f:{
                type: Function,
                require: true,
            },
        },
        data(){
            return {
                popup_info_vb : {val : false},

                currentTotalAvailableFilesNum_n : 0,

                // moveFiles
                moveFile_showPopup_vb : {val : false},
                moveFile_selectedFile_c : null,
                moveFile_folderPath_c : [],

                orderByOptions_byLabel_s : {date: 'date', name: 'name'},
                orderBy_s: 'date',
                filterOptions_byLabel_s : {image: 'image', video: 'video', audio : 'audio'},
                filter_s: null,

                // newFolder
                popup_newFolder_vb : {val : false},
                popup_newFolder_name_s : 'New Folder',

                // editFile
                currentEditFile_c : null,
                currentEditFile_new_c  : null,


                // ==== server ====
                server_rootFiles_byUploadDate_c : undefined,
                server_currentUserData_moreInfo_c : undefined,
                server_currentUserData_c : undefined,

                // ==== store =====
                displayFilesNum_byPath_n : store_getStateValue_vo(store_var.creator_drive_displayFilesNum_byPath_byFileLabel_n).val,
                store_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                currentFoldersPath_ac : store_getStateValue_vo(store_var.creator_drive_foldersPath_ac).val,

                // ==== imports ====
                ass_strings                 : ass_strings,
                ass_svg_drive_white         : ass_svg_drive_white,
                ass_svg_arrow_round_black   : ass_svg_arrow_round_black,
                ass_img_leftArrow_w         : ass_img_arrow_left_w,
                ass_img_leftArrow_b         : ass_img_arrow_left_b,
                ass_svg_newFolder_black     : ass_svg_newFolder_black,
                ass_img_add_b               : ass_img_add_b,
                ass_img_garbage_w           : ass_img_garbage_w,
                ass_img_add_w               : ass_img_add_w,
                ass_img_newFile_c           : ass_img_newFile_c,
                ass_img_image               : ass_img_image,
                ass_img_searchEmpty_b       : ass_img_searchEmpty_b,
                ass_img_videoPlayer         : ass_img_videoPlayer,
                ass_img_info2_b             : ass_img_info2_b,
                ass_img_infoBtn_b           : ass_img_infoBtn_b,
                ass_svg_folder_color        : ass_svg_folder_color,
                ass_img_musicPlayer         : ass_img_musicPlayer,
                ass_svg_film_b              : ass_svg_film_b,
                ass_svg_photo_b             : ass_svg_photo_b,
                format_sizeBytes_s          : format_sizeBytes_s,
                format_date_YYYY_MM_DD_fs   : format_date_YYYY_MM_DD_fs,

            }
        },
        computed:{

            // currentFilePath
            co_currentFolderFiles_sortByDate_ac(){

                let files_byUploadedTime_s = this.m_getFilesWithPath_byUploadDate_c(this.currentFoldersPath_ac)
                let questFiles_ac = obj_toArray_fo(files_byUploadedTime_s)

                // 1) filter by user options
                if(this.filter_s){
                    questFiles_ac = questFiles_ac.filter((file_c) => {
                        switch(this.filter_s){
                            case this.filterOptions_byLabel_s.image:
                                return file_c.fi_m_isImage_fb() || file_c.fi_m_isFolder_fb()
                            case this.filterOptions_byLabel_s.video:
                                return file_c.fi_m_isVideo_fb() || file_c.fi_m_isFolder_fb()
                            case this.filterOptions_byLabel_s.audio:
                                return file_c.fi_m_isAudio_fb() || file_c.fi_m_isFolder_fb()
                        }
                    })
                }

                // 2) sort - orderBy
                questFiles_ac.sort((file1_c, file2_c) => {
                    switch(this.orderBy_s){
                        case this.orderByOptions_byLabel_s.date:
                            return  file1_c.fi_uploadDate_t > file2_c.fi_uploadDate_t ? -1 : 1
                        case this.orderByOptions_byLabel_s.name:
                            return  file1_c.fi_fileName_s > file2_c.fi_fileName_s ? -1 : 1
                    }
                })

                // 3) sort - folder first
                questFiles_ac.sort((file1_c, file2_c) => file1_c.fi_m_isFolder_fb() ? -1 : 1)

                // 4) update currentTotalAvailableFilesNum_n
                this.currentTotalAvailableFilesNum_n = questFiles_ac.length

                // 5) slice display files by
                return questFiles_ac.splice(0, this.co_currentDisplayFiles_n)
            },
            co_moveFile_currentFolderFiles_sortByDate_ac(){

                let files_byUploadedTime_s = this.m_getFilesWithPath_byUploadDate_c(this.moveFile_folderPath_c)

                let questFiles_ac = obj_toArray_fo(files_byUploadedTime_s)
                questFiles_ac.sort((file1_c, file2_c) => file1_c.fi_fileName_s > file2_c.fi_fileName_s ? -1 : 1)
                return questFiles_ac.filter((file1_c) => file1_c.fi_m_isFolder_fb())
            },
            co_currentDisplayFiles_n(){

                if(this.displayFilesNum_byPath_n[JSON.stringify(this.currentFoldersPath_ac)] == null){
                    this.$set(this.displayFilesNum_byPath_n, [JSON.stringify(this.currentFoldersPath_ac)], 20)
                }

                return this.displayFilesNum_byPath_n[JSON.stringify(this.currentFoldersPath_ac)]
            },

            // sizes
            co_totalSize_sum_n(){
                let sum_n = 0

                obj_forEach_f(this.co_totalSize_byType_n, totalSize_n => {
                    sum_n += totalSize_n
                })

                return sum_n
            },
            co_totalSize_byType_n(){

                let sizeBytes_byFileType_n = {
                    images_n : 0,
                    videos_n : 0,
                    audio_n : 0,
                }

                obj_forEach_f(this.server_rootFiles_byUploadDate_c, file_c => {
                    if(file_c.fi_m_isImage_fb()){
                        sizeBytes_byFileType_n.images_n += file_c.fi_sizeBytes_n
                    }else if(file_c.fi_m_isVideo_fb()){
                        sizeBytes_byFileType_n.videos_n += file_c.fi_sizeBytes_n
                    }else if(file_c.fi_m_isAudio_fb()){
                        sizeBytes_byFileType_n.audio_n += file_c.fi_sizeBytes_n
                    }
                })

                return sizeBytes_byFileType_n
            },


        },
        methods:{
            m_showMoreFiles_f(){

                this.displayFilesNum_byPath_n[JSON.stringify(this.currentFoldersPath_ac)] = this.co_currentDisplayFiles_n+10

                store_setStateValue(store_var.creator_drive_displayFilesNum_byPath_byFileLabel_n, this.displayFilesNum_byPath_n)

            },
            m_getFilesWithPath_byUploadDate_c(filePath_ac){
                let files_byUploadedTime_s = this.server_rootFiles_byUploadDate_c
                let pathLength_n = filePath_ac.length

                if(pathLength_n > 0){
                    files_byUploadedTime_s = filePath_ac[pathLength_n-1].fi_folderFiles_byUploadDate_c
                }
                return files_byUploadedTime_s
            },
            m_clickFileName_f(file_c){
                this.currentEditFile_c = file_c
                this.currentEditFile_new_c = new FB_File(file_c)
                date_setTimeout(() => {
                    let inputTag_o = this.$refs.ref_fileName[0]
                    inputTag_o.focus()
                    inputTag_o.setSelectionRange(0,inputTag_o.value.length)

                },10, this.$options.name)
            },
            m_editFileName_onBluer_f(){
                this.currentEditFile_new_c = null
            },
            m_editFileName_saveNewName_f(){
                this.currentEditFile_c.fi_fileName_s = this.currentEditFile_new_c.fi_fileName_s
                this.currentEditFile_new_c=null

                // update files root tree
                serverPre_creatorFiles_update_f({
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    userFiles_byUploadedDate_c : this.server_rootFiles_byUploadDate_c,
                    cb_f        : () => {
                        console.log('finish')
                    }
                })
            },

            m_addFileFromDevice_f(){

                let blob_o = event.target.files[0]
                event.target.value = null

                // file name
                let filePrefix_s = blob_o.name.split(".")[0]
                let fileName_s = filePrefix_s
                let index_n = 0
                while(this.server_rootFiles_byUploadDate_c[fileName_s]){
                    fileName_s = `${filePrefix_s} (${index_n++})`
                }

                // file size
                if(blob_o.size > gv_numbers.maxFileSizeInByte){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_fileIsTooBig)
                    return
                }

                // total drive space
                if(this.co_totalSize_sum_n + blob_o.size > this.server_currentUserData_moreInfo_c.udsmi_tqDriveSize_n){
                    notification_notify2({
                        title_s : ass_strings.oneWord_error[this.store_langCode_ve.val],
                        text_s  : ass_strings.fourWords_tqDriveIsFull[this.store_langCode_ve.val]
                    })
                    return
                }

                // file format
                if(!validator_enum_fb(enum_fileType, blob_o.type)){
                    notification_notify2({
                        title_s : ass_strings.oneWord_error[this.store_langCode_ve.val],
                        text_s  : ass_strings.threeWords_notSupportedFormat[this.store_langCode_ve.val]
                    })
                    return
                }

                // new file
                let newFile_c = new FB_File({
                    fi_fileName_s       : fileName_s,
                    fi_url_s            : URL.createObjectURL(blob_o),
                    fi_type_e           : blob_o.type,
                    fi_sizeBytes_n      : blob_o.size,
                })

                let currentPathFiles_byUploadDate_c = this.m_getFilesWithPath_byUploadDate_c(this.currentFoldersPath_ac)
                this.$set(currentPathFiles_byUploadDate_c, newFile_c.fi_uploadDate_t, newFile_c)

                serverPre_userFiles_add_f({
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    file_c      : newFile_c,
                    blob_o      : blob_o,
                    folderPath_ac : this.currentFoldersPath_ac,
                    cb_f        : () => {
                        console.log('finish')
                    }
                })

            },
            m_deleteFile_f(file_c){

                if(file_c.fi_m_isFolder_fb() && obj_size_fn(file_c.fi_folderFiles_byUploadDate_c) > 0){

                    notification_notify2({
                        title_s : ass_strings.oneWord_notice[this.store_langCode_ve.val],
                        text_s  : ass_strings.sentence_deleteFolderError[this.store_langCode_ve.val]
                    })
                    return
                }


                let current_rootFiles_byUploadDate_c = this.m_getFilesWithPath_byUploadDate_c(this.currentFoldersPath_ac)
                this.$delete(current_rootFiles_byUploadDate_c, file_c.fi_uploadDate_t)
                serverPre_creatorFile_delete_f({
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    folderPath_ac: this.currentFoldersPath_ac,
                    file_c      : file_c,
                    cb_f        : () => {console.log('finish')}
                })



            },
            m_chooseFile_f(file_c){

                if(file_c.fi_uploadStatus_n < 1){
                    return
                }

                console.log(this.p_canChooseVideo_b, this.p_canChooseAudio_b, this.p_canChooseImage_b)
                let cantVideo_b = (file_c.fi_m_isImage_fb() || file_c.fi_m_isGif_fb()) && !this.p_canChooseImage_b
                let cantImage_b = file_c.fi_m_isVideo_fb() && !this.p_canChooseVideo_b
                let cantAudio_b = file_c.fi_m_isAudio_fb() && !this.p_canChooseAudio_b

                if(cantVideo_b || cantImage_b || cantAudio_b){
                    notification_notify2({
                        title_s: ass_strings.oneWord_error[this.store_langCode_ve.val],
                        text_s : ass_strings.sentence_fileType[this.store_langCode_ve.val],
                    })
                    return
                }

                this.pe_chooseFile_f(file_c)
            },
            m_createNewFolder_f(){

                let newFile_c = new FB_File({
                    fi_fileName_s       : this.popup_newFolder_name_s,
                    fi_url_s            : null,
                    fi_type_e           : enum_fileType.folder,
                    fi_sizeBytes_n      : 0,
                    fi_uploadStatus_n   : 1,
                })

                let currentPathFiles_byUploadDate_c = this.m_getFilesWithPath_byUploadDate_c(this.currentFoldersPath_ac)
                this.$set(currentPathFiles_byUploadDate_c, newFile_c.fi_uploadDate_t, newFile_c)
                this.popup_newFolder_vb.val = false

                serverPre_userFiles_add_f({
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    folderPath_ac : this.currentFoldersPath_ac,
                    file_c      : newFile_c,
                    cb_f        : () => {
                        this.popup_newFolder_vb.val = false
                        console.log('finish')
                    }
                })


            },
            m_moveFile_f(){

                // delete old location
                let currentPath_files_byUploadDate_c = this.m_getFilesWithPath_byUploadDate_c(this.currentFoldersPath_ac)
                this.$delete(currentPath_files_byUploadDate_c, this.moveFile_selectedFile_c.fi_uploadDate_t)
                // set new location
                let moveFile_files_byUploadDate_c = this.m_getFilesWithPath_byUploadDate_c(this.moveFile_folderPath_c)
                this.$set(moveFile_files_byUploadDate_c, this.moveFile_selectedFile_c.fi_uploadDate_t, this.moveFile_selectedFile_c)

                // update files root tree
                serverPre_creatorFiles_update_f({
                    userId_uid  : this.server_currentUserData_c.ud_userId_uid,
                    userFiles_byUploadedDate_c : this.server_rootFiles_byUploadDate_c,
                    cb_f        : () => {
                        console.log('finish')
                    }
                })

                this.moveFile_showPopup_vb.val = false
            },
            m_showMoveFilePopup_f(file_c){
                this.moveFile_showPopup_vb.val=true
                this.moveFile_folderPath_c = this.currentFoldersPath_ac.slice()
                this.moveFile_selectedFile_c = file_c
            },

            m_clickFilter_f(newFilter_s){
                if(this.filter_s === newFilter_s){
                    this.filter_s = null
                }else{
                    this.filter_s = newFilter_s
                }
            },

            // currentPath update
            m_currentFolderPath_reset_f(){
                this.currentFoldersPath_ac = []
                store_setStateValue(store_var.creator_drive_foldersPath_ac, this.currentFoldersPath_ac)
            },
            m_currentFolderPath_pop_f(){
                this.currentFoldersPath_ac.pop()
                store_setStateValue(store_var.creator_drive_foldersPath_ac, this.currentFoldersPath_ac)
            },
            m_currentFolderPath_push_f(newFileFolder_c){
                this.currentFoldersPath_ac.push(newFileFolder_c)
                store_setStateValue(store_var.creator_drive_foldersPath_ac, this.currentFoldersPath_ac)
            },
            m_currentFolderPath_splice_f(index_n){
                this.currentFoldersPath_ac = this.currentFoldersPath_ac.splice(0,index_n+1)
                store_setStateValue(store_var.creator_drive_foldersPath_ac, this.currentFoldersPath_ac)
            }

        },
        created(){

            // 1) current user
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {

                if(currentUserData_c == null){
                    return
                }

                serverAuth_currentUserData_remove_vl_f(this.$options.name)

                this.server_currentUserData_c = currentUserData_c

                // 2) current user more info
                serverPre_subUserData_moreInfo_get_f({
                    userId_uid  : currentUserData_c.ud_userId_uid,
                    cb_f        : (currentUser_moreInfo_c) => {
                        this.server_currentUserData_moreInfo_c = currentUser_moreInfo_c
                    }
                })

                // 3) current user files
                serverPre_userFiles_get_f({
                    userId_uid  : currentUserData_c.ud_userId_uid,
                    cb_f    : (questFiles_byFileName_c) => {
                        this.server_rootFiles_byUploadDate_c = questFiles_byFileName_c
                    }
                })
            })
        },
        mounted() {

            if(!this.p_canChooseImage_b || !this.p_canChooseVideo_b || !this.p_canChooseAudio_b){
                if(this.p_canChooseImage_b){
                    this.filter_s = this.filterOptions_byLabel_s.image
                }else if(this.p_canChooseVideo_b) {
                    this.filter_s = this.filterOptions_byLabel_s.video
                }else if(this.p_canChooseAudio_b) {
                    this.filter_s = this.filterOptions_byLabel_s.audio
                }
            }


        }
    }
</script>

<style scoped lang="scss">
    .lc_imgBtns{
        margin-top: -44px;
        position: sticky;
    }

    .lc_fileDate{
        margin-top: -20px;
    }

    .lc_folder{
        max-height: 140px;
    }
</style>